// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 4214) return "static/chunks/4214-13b46843b397d11d.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"960":"bba70c06c3667033","1520":"8f9bab276c5897e1","7005":"713c45b452820374"}[chunkId] + ".js";
};